import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentinshirur() {



  const cardData =
  {
    keyword: 'Bus On Rent in Shirur',
    heading: 'Sanavi Travels: Bus On Rent in Shirur',
    headingDescription: 'Sanavi Travels offers reliable Bus On Rent in Shirur, providing safe, comfortable, and spacious transportation for families, groups, corporate trips, school excursions, weddings, and tourist travel in and around Shirur. Our fleet of well-maintained AC and non-AC buses, mini buses, and luxury coaches ensures smooth rides, ample seating, and sufficient luggage space for a hassle-free journey. With professional drivers, flexible one-way and round-trip bus rental packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free service. We provide convenient pickup and drop services across Shirur, Pune, and nearby areas, making it ideal for local sightseeing, outstation trips, corporate events, and group tours. Choose Sanavi Travels for trusted bus rental services in Shirur, delivering comfort, safety, and a seamless travel experience for every occasion.',

    top: 'Top Places to Visit in Shirur with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shirur Town",
    "description": "Shirur is a prominent town in Pune district, situated on the banks of the Ghod River. Known for its historical significance and agricultural surroundings, Shirur serves as a hub for trade, culture, and education in the region. The town offers visitors a blend of rural charm, historical sites, and vibrant local markets."
  },
  {
    "title": "Bhima Ghat Viewpoints",
    "description": "The hills and ghats near Shirur provide stunning viewpoints overlooking the Ghod River and surrounding farmlands. These scenic spots are ideal for nature walks, photography, and enjoying the tranquility of the countryside."
  },
  {
    "title": "Historic Temples of Shirur",
    "description": "Shirur is home to several temples dedicated to Lord Shiva, Lord Ganesh, and local deities. These temples reflect traditional Maharashtrian architecture and serve as focal points for festivals, religious events, and community gatherings."
  },
  {
    "title": "Chintamani Ganpati Temple",
    "description": "A famous local shrine, Chintamani Ganpati Temple attracts devotees from Shirur and nearby villages. Known for its spiritual ambiance and colorful celebrations during Ganesh Chaturthi, the temple is a key religious landmark."
  },
  {
    "title": "Agricultural Lands and Farms",
    "description": "Shirur is surrounded by fertile agricultural lands, primarily cultivating sugarcane, pomegranates, and other crops. Visitors can experience rural life, traditional farming methods, and seasonal harvest festivals in these lush landscapes."
  },
  {
    "title": "Local Markets and Handicrafts",
    "description": "Shirur hosts vibrant weekly markets where locals sell fresh produce, grains, handicrafts, and traditional items. Exploring these markets gives visitors a taste of rural commerce and community culture."
  },
  {
    "title": "Riverfront Areas",
    "description": "The banks of the Ghod River provide peaceful spots for relaxation, picnics, and early morning walks. The riverfront is especially scenic during the monsoon, with flowing water and lush greenery creating a serene environment."
  },
  {
    "title": "Trekking and Hill Walks",
    "description": "Shirur is surrounded by small hills and ghats offering trekking opportunities for beginners and nature enthusiasts. The trails provide panoramic views of the river valleys, farmland, and rural settlements."
  },
  {
    "title": "Historic Sites and Monuments Nearby",
    "description": "The region around Shirur has several historic forts, shrines, and Maratha-era monuments. These sites provide insight into the local history, architecture, and cultural heritage of the Pune district."
  },
  {
    "title": "Local Cuisine and Eateries",
    "description": "Shirur offers authentic Maharashtrian cuisine with local eateries serving traditional meals, snacks, and sweets. Sampling the regional food provides an immersive cultural experience for visitors exploring the town and its surroundings."
  }
]
,



"services": [
{
"name": "Bus On Rent in Shirur",
"description": "Bus On Rent in Shirur provides reliable and comfortable bus rental services for local travel, group outings, corporate trips, and long-distance journeys. With well-maintained buses, spacious seating, and professional drivers, the service ensures a safe, timely, and hassle-free travel experience for families, tourists, corporate clients, and event organizers. Ideal for day trips, school excursions, religious tours, and weekend getaways, it prioritizes passenger comfort, convenience, and a smooth journey throughout Shirur and nearby areas."
},
{
"name": "Bus Hire Shirur",
"description": "Bus Hire Shirur offers flexible and convenient bus rental solutions for weddings, corporate outings, school trips, picnics, and group tours. Equipped with modern interiors, ample seating, and trained drivers, it ensures a comfortable and safe journey. Transparent pricing, timely pickups, and professional service make Bus Hire Shirur a trusted choice for residents and visitors seeking organized and hassle-free group transportation."
},
{
"name": "AC Bus Shirur",
"description": "AC Bus Shirur provides a comfortable and refreshing travel experience with fully air-conditioned buses suitable for long-distance trips, corporate tours, family travel, and sightseeing. These buses feature spacious seating, smooth rides, and modern amenities, ensuring that passengers enjoy a relaxed and pleasant journey across Shirur and surrounding areas."
},
{
"name": "Luxury Bus Shirur",
"description": "Luxury Bus Shirur offers premium travel experiences with high-end buses featuring reclining seats, ample legroom, and superior comfort. Ideal for VIP travel, corporate tours, wedding parties, and leisure trips, these buses combine elegance, safety, and professional service to provide a memorable and hassle-free travel experience for groups and families."
},
{
"name": "Wedding Bus Shirur",
"description": "Wedding Bus Shirur provides specialized bus services for wedding guests, pre-wedding events, and destination weddings. Spacious and well-maintained buses with professional drivers ensure comfortable, timely, and stress-free transportation, allowing families and friends to travel together with ease during wedding celebrations in and around Shirur."
},
{
"name": "Corporate Bus Shirur",
"description": "Corporate Bus Shirur offers organized and professional transportation for businesses and organizations, including office trips, meetings, conferences, and corporate events. Punctual service, experienced drivers, and comfortable buses ensure smooth and efficient travel, making corporate commuting and event transportation seamless and reliable."
},
{
"name": "Outstation Bus Shirur",
"description": "Outstation Bus Shirur specializes in long-distance travel services to nearby cities, hill stations, and tourist destinations. With well-maintained buses, skilled drivers, and flexible itineraries, it guarantees a safe, comfortable, and convenient journey for families, groups, and tourists exploring destinations beyond Shirur."
},
{
"name": "Affordable Bus Shirur",
"description": "Affordable Bus Shirur delivers cost-effective bus rental services without compromising on comfort or safety. Perfect for families, school groups, religious tours, and social outings, this service combines economical pricing, reliable buses, and professional drivers to provide dependable transportation for all types of travelers."
},
{
"name": "Chauffeur Driven Bus Shirur",
"description": "Chauffeur Driven Bus Shirur ensures a stress-free travel experience with trained and professional drivers who handle navigation, traffic, and scheduling efficiently. Ideal for group travel, corporate trips, leisure tours, and family outings, passengers can relax and enjoy the journey while the driver manages the entire trip safely."
},
{
"name": "Best Bus Service Shirur",
"description": "Best Bus Service Shirur is recognized for its punctuality, clean buses, and customer-focused approach. Suitable for tourist travel, corporate trips, family outings, and group excursions, it guarantees reliable, safe, and comfortable transportation with professional drivers for a smooth and enjoyable journey."
},
{
"name": "Tourist Bus Shirur",
"description": "Tourist Bus Shirur caters to travelers exploring Shirur and nearby attractions. With flexible itineraries, experienced drivers, and comfortable seating, it provides a convenient and memorable sightseeing experience. Passengers can enjoy scenic locations, cultural sites, and heritage spots without worrying about travel logistics or navigation."
},
{
"name": "Group Travel Bus Shirur",
"description": "Group Travel Bus Shirur offers organized transportation for large groups such as families, friends, corporate teams, and tour groups. With coordinated planning, spacious buses, and reliable drivers, it ensures that everyone travels together safely and comfortably, making group trips seamless and enjoyable."
},
{
"name": "Online Bus Booking Shirur",
"description": "Online Bus Booking Shirur allows travelers to reserve buses quickly and conveniently with instant confirmation. Multiple bus options, flexible schedules, and transparent pricing make trip planning efficient and stress-free for families, tourists, corporate clients, and social groups visiting Shirur."
},
{
"name": "Event Bus Shirur",
"description": "Event Bus Shirur provides dedicated transportation for weddings, corporate events, parties, exhibitions, and special occasions. With professional drivers, reliable scheduling, and comfortable buses, it ensures smooth and organized movement of guests and participants, making event travel in and around Shirur seamless and enjoyable."
},
{
"name": "Shirur Travel Bus",
"description": "Shirur Travel Bus provides complete travel solutions for local sightseeing, outstation trips, corporate travel, and group excursions. Combining comfort, safety, affordability, and professional service, it caters to families, tourists, corporate clients, and large groups seeking dependable and hassle-free bus transportation in Shirur and nearby regions."
}
],
"tableData": [
["Bus On Rent in Shirur", "Bus Hire Shirur"],
["AC Bus Shirur", "Luxury Bus Shirur"],
["Wedding Bus Shirur", "Corporate Bus Shirur"],
["Outstation Bus Shirur", "Affordable Bus Shirur"],
["Chauffeur Driven Bus Shirur", "Best Bus Service Shirur"],
["Tourist Bus Shirur", "Group Travel Bus Shirur"],
["Online Bus Booking Shirur", "Event Bus Shirur"],
["Shirur Travel Bus", "—"]
]
,



"whychoose": [
  {
    "WhyChooseheading": "Bus On Rent in Shirur with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable bus rental services in Shirur, perfect for group outings, school trips, family tours, and corporate travel."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Buses",
    "WhyChoosedescription": "Our buses are clean, air‑conditioned, and regularly serviced to ensure a smooth and enjoyable journey throughout Shirur and nearby destinations."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are familiar with Shirur routes, ensuring safe, punctual, and stress‑free travel for your group."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for bus rentals in Shirur, covering fuel, tolls, and driver allowances with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, travel queries, and trip planning for your bus hire in Shirur."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, half‑day, full‑day, or customized rental packages based on your group’s needs and travel schedule."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for bus rentals in Shirur."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services in Shirur?',
    answer: 'Yes, Sanavi Travels offers reliable bus rental services in Shirur for various travel needs.'
  },
  {
    question: 'How can I book a bus in Shirur?',
    answer: 'You can easily book a bus through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for rent in Shirur?',
    answer: 'Sanavi Travels offers a variety of buses including mini buses, 20‑seater, 32‑seater, 45‑seater, and 50‑seater options to suit your group size.'
  },
  {
    question: 'Are the drivers experienced with routes around Shirur?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with Shirur routes, ensuring safe and timely travel.'
  },
  {
    question: 'Can I choose custom pickup and drop‑off locations in Shirur?',
    answer: 'Absolutely. You can select your preferred pickup and drop‑off locations anywhere in Shirur and nearby areas.'
  },
  {
    question: 'Is the bus service in Shirur available 24x7?',
    answer: 'Yes, Sanavi Travels offers round‑the‑clock bus rental services in Shirur to suit your travel schedule.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available for bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for your bus rental bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your trip in Shirur.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ajay Pawar',
    feedback: 'We rented a bus in Shirur from Sanavi Travels and had a fantastic trip—clean bus, friendly driver, and excellent service!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Rutuja More',
    feedback: 'Sanavi Travels provided dependable bus rental service in Shirur—very comfortable journey. Highly recommended!',
    rating: 5
  }
];













































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Bus On Rent in Shirur - Sanavi Travels",
  "description": "Sanavi Travels provides AC, luxury, wedding, corporate, and outstation buses on rent in Shirur. Chauffeur-driven buses for tourist trips, group travel, events, and online booking with reliable service.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "34"
  }
};



  return (
    <div>
<Helmet>
  <title>
    Bus On Rent in Shirur | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Sanavi Travels provides AC, luxury, wedding, corporate, and outstation buses on rent in Shirur. Chauffeur-driven buses for tourist trips, group travel, events, and online booking with reliable service."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/133.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentinshirur;